import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/lib/utils/useIsMobile';
import { Layout } from './layout';
import { MobileLayout } from './MobileLayout';

export function ResponsiveLayout({ children }) {
  const isMobile = useIsMobile();
  const location = useLocation();
  
  if (isMobile) {
    return <MobileLayout>{children}</MobileLayout>;
  }
  
  return <Layout>{children}</Layout>;
}